import React from "react";

// کارت پایه برای بخش‌های پنل
export function SectionCard({ title, action, children, className = "" }) {
  return (
    <div className={`rounded-2xl bg-white p-5 shadow-card ${className}`}>
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between">
          {title && <h3 className="text-sm font-bold text-navy">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

// حالت لودینگ ساده
export function Spinner({ label = "در حال بارگذاری..." }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-14">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-sky border-t-transparent" />
      <p className="text-xs text-gray-400">{label}</p>
    </div>
  );
}

// حالت خطا با دکمه تلاش مجدد
export function ErrorState({ message, onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl bg-red-50 py-10 text-center">
      <p className="text-sm font-bold text-red-600">
        {message || "خطایی در دریافت اطلاعات رخ داد"}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="rounded-lg bg-white px-4 py-1.5 text-xs font-bold text-red-600 shadow-sm transition hover:bg-red-100"
        >
          تلاش مجدد
        </button>
      )}
    </div>
  );
}

// حالت خالی بودن لیست
export function EmptyState({ icon = "📭", title, description }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-14 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-surface text-2xl">
        {icon}
      </div>
      <p className="text-sm font-bold text-navy">{title}</p>
      {description && (
        <p className="max-w-xs text-xs text-gray-400">{description}</p>
      )}
    </div>
  );
}

// کارت آمار کوچک (برای بخش مالی)
export function StatCard({ label, value, icon, tone = "sky" }) {
  const toneMap = {
    sky: "bg-sky/10 text-sky-dark",
    green: "bg-green-100 text-green-600",
    red: "bg-red-50 text-red-600",
    navy: "bg-navy/5 text-navy",
  };
  return (
    <div className="flex items-center gap-3 rounded-xl border border-gray-100 p-4">
      <div
        className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-lg ${toneMap[tone] || toneMap.sky}`}
      >
        {icon}
      </div>
      <div className="min-w-0">
        <p className="text-[11px] font-semibold text-gray-400">{label}</p>
        <p className="truncate text-base font-extrabold text-navy">{value}</p>
      </div>
    </div>
  );
}

// نشان وضعیت (برای قولنامه‌ها و تراکنش‌ها)
const STATUS_STYLES = {
  completed: { label: "تکمیل‌شده", cls: "bg-green-100 text-green-700" },
  pending_buyer: {
    label: "در انتظار تکمیل",
    cls: "bg-yellow-100 text-yellow-700",
  },
  pending_seller: {
    label: "در انتظار تکمیل",
    cls: "bg-yellow-100 text-yellow-700",
  },
  cancelled: { label: "لغو شده", cls: "bg-red-50 text-red-600" },
  draft: { label: "پیش‌نویس", cls: "bg-gray-100 text-gray-600" },
};

export function StatusBadge({ status }) {
  const style = STATUS_STYLES[status] || {
    label: status || "نامشخص",
    cls: "bg-gray-100 text-gray-600",
  };
  return (
    <span
      className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold ${style.cls}`}
    >
      {style.label}
    </span>
  );
}

// دکمه صفحه‌بندی ساده
export function Pagination({ page, totalPages, onChange }) {
  if (!totalPages || totalPages <= 1) return null;
  return (
    <div className="mt-4 flex items-center justify-center gap-2">
      <button
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-bold text-navy transition hover:border-sky disabled:cursor-not-allowed disabled:opacity-40"
      >
        قبلی
      </button>
      <span className="text-xs font-bold text-gray-500">
        صفحه {page} از {totalPages}
      </span>
      <button
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-bold text-navy transition hover:border-sky disabled:cursor-not-allowed disabled:opacity-40"
      >
        بعدی
      </button>
    </div>
  );
}
